import React from "react";
import { Row, Col } from "react-bootstrap";

const SharedTab = () => {
  return (
    <>
      <section className="">
        <Row className="my-lg-4 my-2 pt-3 justify-content-center margin_bottomfooter mb-5">
          <Col lg={12} xxl={11}>
            <Row>
              <Col xs={12} className="mb-0">
                <div className="justify-content-between flex-wrap bg-white px-5 pt-4 pb-4">
                  No Shared Safari Found
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </section>
    </>
  );
};

export default SharedTab;
